interface Date {
  addDays(days: number): Date;
  addMonth(month: number): Date;
}

Date.prototype.addDays = function(days: number): Date {
  const newDate = new Date(JSON.parse(JSON.stringify(this)));
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

Date.prototype.addMonth = function(month: number): Date {
  const newDate = new Date(JSON.parse(JSON.stringify(this)));
  newDate.setMonth((newDate.getMonth() + month));
  return newDate;
};
